// src/pages/support/components/StatusBadge.jsx
import React from "react";
import Badge from "./Badge";

function StatusBadge({ status }) {
  const active = (status || "").toLowerCase() === "active";
  return active ? (
    <Badge>فعال</Badge>
  ) : (
    <Badge color="#ef4444" bg="rgba(239,68,68,0.15)" border="rgba(239,68,68,0.35)">
      غیرفعال
    </Badge>
  );
}

export default StatusBadge;